import { service } from '../../../../helpers/http'

export const ActionGetTravelTimes = ({ dispatch }, payload) => {
    return service({
        module: 'domainAmbienceTravelTime',
        action: 'getTravelTimes',
        payload: payload
    })
}

export const ActionPostTravelTime = ({ dispatch }, payload) => {
    return service({
        module: 'domainAmbienceTravelTime',
        action: 'postTravelTime',
        payload: payload
    })
}

export const ActionPutTravelTime = ({ dispatch }, payload) => {
    return service({
        module: 'domainAmbienceTravelTime',
        action: 'putTravelTime',
        payload: payload
    })
}

export const ActionDeleteTravelTime = ({ dispatch }, payload) => {
    return service({
        module: 'domainAmbienceTravelTime',
        action: 'deleteTravelTime',
        payload: payload
    })
}
